import { Attributes, List, LookupBase, NeoModel } from '@singularsystems/neo-core';
import LiquidityUtilisationLookup from '../../InvestorInvestments/Lookups/LiquidityUtilisationLookup';

@NeoModel
export default class UtilisationLookup extends LookupBase {

    @Attributes.Float()
    public issuerInvestmentBalance: number = 0;

    @Attributes.Float()
    public utilisedAmount: number = 0;

    public hasLiquidityProviders: boolean = false;

    public liquidityUtilisation = new List(LiquidityUtilisationLookup);

    // Client only properties / methods

    public getSpareCapacity(isLiquidityProvider: boolean) {
        let spareCapacity = this.issuerInvestmentBalance - this.utilisedAmount;
        if (this.hasLiquidityProviders && !isLiquidityProvider) {
            spareCapacity += this.liquidityUtilisation.sum(c => c.balance);
        }
        return spareCapacity;
    }

    public get maxLiquidity() {
        if (this.hasLiquidityProviders) {
            const maxHoldingPercent = this.liquidityUtilisation.sum(c => c.maxHoldingPercent);
            return maxHoldingPercent * this.issuerInvestmentBalance;
        }
        return 0;
    }

    public get remainingLiquidity() {
        if (this.hasLiquidityProviders) {
            return Math.max(0, this.maxLiquidity - this.liquidityUtilisation.sum(c => c.liquidityBalance));
        }
        return 0;
    }
}